import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {AxiosError} from 'axios';
import {ProviderCode} from '@shipwell/genesis-sdk';
import {COMPANY_INTEGRATION_CHR_DISCONNECT} from 'App/data-hooks/queryKeys';
import {deleteProvider} from 'App/api/integrations/typed';

const useDisconnectChRobinsonMutation = (options: UseMutationOptions<unknown, AxiosError>) =>
  useMutation([COMPANY_INTEGRATION_CHR_DISCONNECT], () => deleteProvider(ProviderCode.Chrobinson), options);

export default useDisconnectChRobinsonMutation;
